import React from "react";
import {TextField} from "../../../../../shared/TextField";
import { FormattedMessage } from "react-intl";
import { Table } from "reactstrap";
import {SimpleRow} from "../../../../../layout/Table/SimpleRow";

function AdminFields({ formikProps, user }) {

  return (
    <Table className="align-items-center table-flush" responsive striped>
      <tbody>
      <SimpleRow translationKey="components.pages.users.usersTable.table.id"
                 value={user.id}/>
      <tr>
        <td>
          <FormattedMessage id="fields.firstName"/>
        </td>
        <td className="pt-0 pb-0">
          <TextField
            name="firstName"
            value={formikProps.values.firstName}
            classNameFormGroup="m-0"
            onChange={(e) =>
              formikProps.setFieldValue( "firstName", e.target.value )
            }
          />
        </td>
      </tr>
      <tr>
        <td>
          <FormattedMessage id="fields.lastName"/>
        </td>
        <td className="pt-0 pb-0">
          <TextField
            name="lastName"
            value={formikProps.values.lastName}
            classNameFormGroup="m-0"
            onChange={(e) => formikProps.setFieldValue( "lastName", e.target.value )}
          />
        </td>
      </tr>
      <tr>
        <td>
          <FormattedMessage id="fields.email"/>
        </td>
        <td className="pt-0 pb-0">
          <TextField
            name="email"
            value={formikProps.values.email}
            classNameFormGroup="m-0"
            onChange={(e) => formikProps.setFieldValue( "email", e.target.value )}
            required
          />
        </td>
      </tr>
      </tbody>
    </Table>
  );
}

export { AdminFields };
